import React from "react";
import { Link } from "gatsby";
import * as c from "./lcChildLinksBlocks.module.scss";

export default function LcChildLinksBlock({ links, useSeparator }) {
  if (links.length === 0) return null;

  return (
    <div className={c.container}>
      {useSeparator && <hr />}
      <h2>In this section:</h2>
      <ul>
        {links.map((link, idx) => {
          return (
            <li key={idx} className={c.link}>
              <Link to={link.path}>{link.title}</Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
